import * as React from "react";

import styled from "styled-components";
import { getGroups } from "../api/api";
import { Breadcrumb, Button, Table } from "antd";
// import MissionItem from "../comp/missionitem";

import { getUserMission } from "../api/api";
import moment from "moment";

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .rightcontent {
    flex: 1;
    .list {
      display: flex;
      flex-wrap: wrap;
    }
  }
`;

const MissionList: React.FunctionComponent = () => {
  const [alist, setalist] = React.useState<Array<any>>([]);

  const agetList = async () => {
    const ret = await getGroups({
      pageNum: 1000,
      pageSize: 10,
    });
    setalist(ret?.myGroups ?? []);
  };

  React.useEffect(() => {
    agetList();
  }, []);

  const downloadMission = async (item: any) => {
    const ret = await getUserMission({ groupId: item.id });
    const { myAllUserMissionsByGroupIdUrl } = ret;
    const urls = myAllUserMissionsByGroupIdUrl;
    // window.open(urls);
    const a = document.createElement("a");

    a.download = `${item.name}-日志-${moment().format("YYYY-MM-DD")}.txt`;
    a.href = urls;
    a.target = "_blank";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const columns = [
    { title: "组名", dataIndex: "name", key: "name", width: "70%" },
    {
      title: "操作",
      dataIndex: "x",
      render: (_: string, record: any) => (
        <Button
          // size="small"
          type="primary"
          onClick={() => downloadMission(record)}
        >
          导出全部日志
        </Button>
      ),
    },
  ];

  return (
    <Container>
      <div className="rightcontent">
        <div className="breadCrmb">
          <Breadcrumb>
            <Breadcrumb.Item>
              <span className="p">首页</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>日志导出</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="list">
          {/* {(alist ?? []).map((x: any) => (
            <MissionItem item={x} key={`${x.id}+${Math.random}`} />
          ))}
          {(alist ?? []).length === 0 && (
            <div className="jsc fs16 mt50">暂无数据</div>
          )} */}
          <Table
            columns={columns}
            dataSource={alist}
            pagination={false}
            bordered
            style={{ width: "80%" }}
            key="name"
          />
        </div>
      </div>
    </Container>
  );
};

export default MissionList;
